module.exports = __webpack_public_path__ + "static/media/pdf.87c91703.svg";